import { IContainer, ILazyBinder, injectContainer } from '../../interface/container';
import type { IServiceWorkerClient } from './worker';

export interface IServiceWorkerController {
    start: (url: string, scope: string) => IServiceWorkerClient;
    active: () => IServiceWorkerClient | undefined;
    terminate: () => void;
}

const TYPES = {
    IServiceWorkerController: Symbol.for('IServiceWorkerController'),
};

export function injectServiceWorkerController(
    container: IContainer = injectContainer(),
): Promise<IServiceWorkerController> {
    return container.get<ILazyBinder<IServiceWorkerController>>(TYPES.IServiceWorkerController)();
}

export function bindServiceWorkerController(
    val: ILazyBinder<IServiceWorkerController>,
    container: IContainer = injectContainer(),
) {
    return container.bind<ILazyBinder<IServiceWorkerController>>(
        TYPES.IServiceWorkerController,
        val,
    );
}

export function unbindServiceWorkerController(container: IContainer = injectContainer()) {
    return container.remove(TYPES.IServiceWorkerController);
}
